export default "__VITE_ASSET__DNqV9Rsy__"